import BaseStore from './BaseStore'

export class WorkflowProcessStore extends BaseStore {
  constructor() {
    super()
    this.endpoint = 'workflow_processes'
  }
}

export default new WorkflowProcessStore()


// WEBPACK FOOTER //
// ./src/stores/WorkflowProcessStore.js